import { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { ArticleFormat, BrandKey } from '../../../__generated__/queries-web';
import { ArticleEdit } from '../ArticleEdit';
import { SuspendTask } from '../../../components/SuspendTask';
import { useDuplicateArticle } from './useDuplicateArticle';

interface ArticleRouteProps {
  articleType: ArticleFormat;
  brandKey: BrandKey;
  versionId: string;
  rawArticleId: string;
}

export const EditDuplicatedArticle: FC<RouteComponentProps<
  ArticleRouteProps
>> = ({ match }) => {
  const duplicateArticleTask = useDuplicateArticle(match.params);

  return (
    <SuspendTask
      task={duplicateArticleTask}
      fallback={
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
          }}
        >
          <CircularProgress size={80} />
          <p style={{ marginTop: '1rem', fontSize: '1.5rem' }}>
            Chargement des données article en cours...
          </p>
        </div>
      }
    >
      {({ sourceArticle, webArticle }) => (
        <ArticleEdit
          data={webArticle}
          subjectId={sourceArticle.assignment.subject.id}
          subjectTitle={sourceArticle.assignment.subject.title}
          disableConcurrentialAccess={true}
        />
      )}
    </SuspendTask>
  );
};
